import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AutomaticStreakCguState {
  // Local acknowledgment state (for UI checkboxes)
  riskAcknowledged: boolean;
  automatedTradingAcknowledged: boolean;
  termsAndConditionsAccepted: boolean;

  // Actions
  setRiskAcknowledged: (acknowledged: boolean) => void;
  setAutomatedTradingAcknowledged: (acknowledged: boolean) => void;
  setTermsAndConditionsAccepted: (accepted: boolean) => void;

  // Reset
  reset: () => void;
}

export const useAutomaticStreakCguStore = create<AutomaticStreakCguState>()(
  persist(
    (set) => ({
      // Initial state
      riskAcknowledged: false,
      automatedTradingAcknowledged: false,
      termsAndConditionsAccepted: false,

      // Actions
      setRiskAcknowledged: (acknowledged) => set({ riskAcknowledged: acknowledged }),
      setAutomatedTradingAcknowledged: (acknowledged) => set({ automatedTradingAcknowledged: acknowledged }),
      setTermsAndConditionsAccepted: (accepted) => set({ termsAndConditionsAccepted: accepted }),

      // Reset
      reset: () =>
        set({
          riskAcknowledged: false,
          automatedTradingAcknowledged: false,
          termsAndConditionsAccepted: false,
        }),
    }),
    {
      name: "automatic-streak-cgu-storage",
      partialize: (state) => ({
        riskAcknowledged: state.riskAcknowledged,
        automatedTradingAcknowledged: state.automatedTradingAcknowledged,
        termsAndConditionsAccepted: state.termsAndConditionsAccepted,
      }),
    },
  ),
);
